import { AxiosRequestConfig } from 'axios'

export interface ReviewsFilters {
  dateFrom?: string
  dateTo?: string
  storeId?: number | ''
  minStars?: number | ''
  maxStars?: number | ''
  source?: string
  responded?: 'all' | 'true' | 'false'
}

const buildReviewsParams = (filters: ReviewsFilters): Record<string, string | number> => {
  const params: Record<string, string | number> = {}
  if (filters.dateFrom) params.dateFrom = filters.dateFrom
  if (filters.dateTo) params.dateTo = filters.dateTo
  if (filters.storeId !== '' && filters.storeId != null) params.storeId = filters.storeId
  if (filters.minStars !== '' && filters.minStars != null) params.minStars = filters.minStars
  if (filters.maxStars !== '' && filters.maxStars != null) params.maxStars = filters.maxStars
  if (filters.source && filters.source !== 'all') params.source = filters.source
  if (filters.responded && filters.responded !== 'all') params.responded = filters.responded
  return params
}

const getReviews = (filters: ReviewsFilters): AxiosRequestConfig => ({
  url: '/reviews',
  method: 'GET',
  params: buildReviewsParams(filters),
})

const downloadReviewsCsv = (filters: ReviewsFilters): AxiosRequestConfig => ({
  url: '/reviews/export/csv',
  method: 'GET',
  params: buildReviewsParams(filters),
  responseType: 'blob',
})

const updateReviewResponded = (id: number, responded: boolean): AxiosRequestConfig => ({
  url: `/reviews/${id}/responded`,
  method: 'PATCH',
  data: { responded },
})

const replyToNativeReview = (reviewId: number, comment: string): AxiosRequestConfig => ({
  url: `/reviews/${reviewId}/reply`,
  method: 'POST',
  data: { comment },
})

export { getReviews, downloadReviewsCsv, updateReviewResponded, replyToNativeReview }
